export const SITUACOES = {
  LANCADO: "LANÇADO",
  PENDENTE: "PENDENTE",
  CANCELADO: "CANCELADO",
  APROVADO: "APROVADO",
  NAO_REALIZADO: "NAO_REALIZADO",
  REALIZADO: "REALIZADO",
  FINALIZADO : "FINALIZADO"
};
